import axios from "axios";
import { SessionHelper } from "@/helpers/sessionHelper";

let faktoolApiInstance = null;

function initApi() {
  faktoolApiInstance = axios.create({
    baseURL: import.meta.env.VITE_FAKTOOL_API_URL
  });

  faktoolApiInstance.interceptors.request.use(config => {
    if (SessionHelper.accessToken || SessionHelper.relogin()) {
      // Static Web Apps overwrites the standard Authorization header on requests to its
      // managed functions, so the Faktool token travels in X-Authorization instead.
      config.headers["X-Authorization"] = `Bearer ${SessionHelper.accessToken}`;
    }

    return config;
  });

  faktoolApiInstance.interceptors.response.use(undefined, async error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // Session ended - try to relogin
          if (await SessionHelper.relogin()) {
            error.config.headers["X-Authorization"] = `Bearer ${SessionHelper.accessToken}`;
            return axios.request(error.config);
          }
          break;

        default:
          break;
      }
    }
    return Promise.reject(error);
  });
}

export function faktoolApi() {
  if (!faktoolApiInstance) {
    initApi();
  }
  return faktoolApiInstance;
}
